module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo1-1efe84dca08e0add76812610bc137aed.jpg";